<template>
	<div class="screen game">
		<div class="game-content">
			
			<div class="game-col left">
				<inventory />
				<hover />
			</div>
			<div class="game-col middle">
				<board />
				<end-game />
			</div>
			<div class="game-col right">
				<mapping />
			</div>

		</div>

		<transition name="level">
			<div v-show="title_visible" class="level">{{ title }}</div>
		</transition>

		<div v-show="protection_visible" v-hammer:pan="pan" class="screen-protection"></div>

		<div class="back-button" @click="back()"></div>

	</div>
</template>

<script>
import { mapGetters } from 'vuex'
import Board from '@/components/game/board.vue'
import Inventory from '@/components/game/inventory.vue'
import Hover from '@/components/game/hover.vue'
import Mapping from '@/components/game/mapping.vue'
import EndGame from '@/components/game/end-game.vue'

export default {
	name: 'game',
	data: function() {
		return {
			title_visible: false
		}
	},
	computed: Object.assign(mapGetters([ 'lang', 'game', 'current' ]), {
		title: function() {
			var temp = this.current.biome[this.lang].name
			if (this.current.location != 'main')
				temp = this.game.current[this.current.location].card[this.lang].name
			return temp
		},
		protection_visible: function() {
			return (this.current.status != 'ready' && this.current.status != 'win' && this.current.status != 'lose') || this.title_visible
		}
	}),
	watch: {
		'current.location': function(newValue, oldvalue) {
			this.show_title()
		},
		'current.level': function(newValue, oldvalue) {
			if (newValue > oldvalue) this.show_title()
		}
	},
	methods: {
		pan: function() {

		},
		back: function() {
			this.$store.dispatch('set_screen', { screen: 'home' })
			this.$store.dispatch('clean_game')
		},
		show_title: function() {
			var self = this
			self.title_visible = true
			setTimeout(function() {
				self.title_visible = false
			}, 1500)
		}
	},
	mounted: function() {
		this.$nextTick(function() {
			this.show_title()
		})
	},
	components: { Board, Inventory, Hover, Mapping, EndGame }
}
</script>

<style lang="stylus">
@import '../assets/css/app'
@import '../assets/css/animations'

.game
	.game-content
		position absolute
		left 50%
		top calc(50% + 24px)
		height ((card_height + 8px) * 4 + 8px)
		transform translate(-50%, -50%)
		width ((card_width + 8) * 3 + (224px + 48px) * 2)
		.game-col
			float left
			height 100%
			width 224px
			&.left
				margin 0 32px 0 0 
			&.middle
				margin 0 16px
				width ((card_width + 8) * 3)
			&.right
				margin 0 0 0 32px
	.level
		position absolute
		top 50%
		left 0
		right 0
		height 128px
		margin-top -64px
		z-index 14
		transform translateY(0)
		transition 0.5s easeOutQuart
		background-color darken(dark, 50%)
		font-size 3.2rem
		line-height @height
		text-align center
		&.level-enter
			transform translateY(-200%)
			opacity 0
		&.level-leave-to
			transform translateY(200%)
			opacity 0
	.screen-protection
		position absolute
		left 0
		top 0
		right 0
		bottom 0
		z-index 100000
	.back-button
		position absolute
		left 16px
		top 16px
		width 32px
		height 32px
		background url(../assets/img/ui/icons.png) (-32px * 4) (-32px * 1)
		background-size auto 64px
		opacity 0.25
		cursor pointer 1
		&:hover
			opacity 1

@media screen and (max-width: 420px)
	.game .game-content
		transform translate(-50%, -50%) scale(0.9)
		
@media screen and (max-width: 375px)
	.game .game-content
		transform translate(-50%, -50%) scale(0.8)
		
@media screen and (max-width: 330px)
	.game .game-content
		transform translate(-50%, -50%) scale(0.75)

</style>
